"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGame = void 0;
const challenge_1 = require("./challenge");
const detail_1 = require("./detail");
const email_1 = require("./email");
const game_form_1 = require("./game-form");
const gameAdvanced_1 = require("./gameAdvanced");
const leader_board_view_1 = require("./leader-board-view");
const prize_1 = require("./prize");
const start_button_1 = require("./start-button");
const terms_view_1 = require("./terms-view");
const view_1 = require("./view");
const views_1 = require("./views");
const externalLeaderBoard_1 = require("./externalLeaderBoard");
const welcome_email_1 = require("./welcome-email");
const tutorial_1 = require("./tutorial");
const game_userbase_1 = require("./game-userbase");
const luckBasedWin_1 = require("./luckBasedWin");
exports.defaultGame = {
    detail: detail_1.detail,
    startButton: start_button_1.startButton,
    view: view_1.view,
    leaderBoardView: leader_board_view_1.leaderBoardView,
    termsView: terms_view_1.termsView,
    gameForm: game_form_1.gameForm,
    challenge: challenge_1.challenge,
    views: views_1.views,
    prize: prize_1.prize,
    gameAdvanced: gameAdvanced_1.gameAdvanced,
    email: email_1.email,
    externalLeaderBoard: externalLeaderBoard_1.externalLeaderBoard,
    welcomeEmail: welcome_email_1.welcomeEmail,
    tutorial: tutorial_1.tutorial,
    gameUseBase: game_userbase_1.gameUseBase,
    luckBasedWin: luckBasedWin_1.luckBasedWin,
};
